import React, { useMemo } from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import { SgSessionStorageService } from 'saga-modules';
import CommonConstants from 'sg-common-constants';
import SgSphIpid from 'sg-sph-ipid';
import SgSpmIpid from 'sg-spm-ipid';
import SgSmiIpid from 'sg-smi-ipid';
import SgSptIpid from 'sg-spt-ipid';
import { useSgAdobeAnalyticsSmiIpidAndRetrieval } from 'sg-adobe-analytics';
import metadata from './IpidPage.metadata.json5';

function IpidPage() {
    const model = SgSessionStorageService.getItem(SgSessionStorageService.KEY.MODEL);
    useSgAdobeAnalyticsSmiIpidAndRetrieval();
    const { productCode } = model.baseData;
    const ipidPageComponent = useMemo(() => {
        let ipidComponent;
        switch (productCode) {
            case CommonConstants.PRIVATE_MEDICAL_INSURANCE_CODE:
                ipidComponent = SgSmiIpid;
                break;
            case CommonConstants.MOTOR_PRODUCT_CODE:
                ipidComponent = SgSpmIpid;
                break;
            case CommonConstants.HOME_PRODUCT_CODE:
                ipidComponent = SgSphIpid;
                break;
            case CommonConstants.TRAVEL_PRODUCT_CODE:
                ipidComponent = SgSptIpid;
                break;
            default:
        }
        return ipidComponent;
    }, [productCode]);

    const overrides = {
        ipidComponentContent: {
            model: model
        }
    };

    const resolvers = {
        resolveComponentMap: {
            ipidPageComponent: ipidPageComponent
        }
    };

    return (
        <div>
            {renderContentFromMetadata(metadata.componentContent, overrides, resolvers)}
        </div>
    );
}
export default withRouter(IpidPage);
